module.exports = __webpack_public_path__ + "static/media/scale-demo.ff65f7f2.mp4";